import { init as initPlayers } from '../video-player/init-players';
import { VIDEO_PLAYER_PLAYERTYPE, VIDEO_PLAYER_STATUS } from '../video-player/constants';
import { isMobile } from '../../utils/device-utils';
import { getLabel } from '../../labels/labelling-service';
import { heroDisclaimer } from '../hero-disclaimer/hero-disclaimer';
import { $mediaWrapper } from '../sticky-hero-player/constants';

import { CAROUSEL_INLINE_CLASSNAME, initPreactCarousel, redirectToFirstVideoUrl, switchMobileCards } from './helpers';

const PLAYER_CLASSNAME = '.j-player';
const DISCLAIMER_TEXT_PREROLL = getLabel('disclaimer.preroll');
const DISCLAIMER_TEXT_REDIRECT = getLabel('disclaimer.redirect');
const videoArticlePageDisclaimer = heroDisclaimer({
  elementToAppendTo: $mediaWrapper,
});

const handleHeroPlayerEvents = (heroPlayer) => {
  if (!heroPlayer) {
    return;
  }

  heroPlayer.on(VIDEO_PLAYER_STATUS.AD_PLAY, async () => {
    videoArticlePageDisclaimer.render({
      disclaimerTitle: DISCLAIMER_TEXT_PREROLL,
    });
  });

  heroPlayer.on(VIDEO_PLAYER_STATUS.AD_COMPLETE, async () => {
    videoArticlePageDisclaimer.dispose();
  });

  heroPlayer.on(VIDEO_PLAYER_STATUS.COMPLETE, async () => {
    redirectToFirstVideoUrl();
  });

  heroPlayer.on(VIDEO_PLAYER_STATUS.THIRD_QUARTILE, async () => {
    const $carouselInline = document.querySelector(CAROUSEL_INLINE_CLASSNAME);
    if ($carouselInline) {
      videoArticlePageDisclaimer.render({
        disclaimerTitle: DISCLAIMER_TEXT_REDIRECT,
      });
    }
  });
};

export const init = () => {
  const videosOnPage = document.querySelectorAll(PLAYER_CLASSNAME);
  const players = initPlayers(videosOnPage);

  if (isMobile()) {
    switchMobileCards();
  } else {
    initPreactCarousel();
  }

  players?.playerConfigList?.forEach((playerConfig, index) => {
    if (playerConfig.playersetup.playertype === VIDEO_PLAYER_PLAYERTYPE.HERO) {
      handleHeroPlayerEvents(players.playerList[index]);
    }
  });
};
